/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './visPreview.scss';
import './fakeVisPreview.scss';

const FAKE_STYLES = {
	text: {
		width: '150px',
		height: '15px',
		marginLeft: '8px',
		marginBottom: '8px'
	}
};

class FakeVisualizationPreview extends Component {

	render() {
		let classNames = classnames(
			'vis-recommender__preview',
			`vis-recommender__preview__size-${this.props.size}`,
			'vis-recommender__preview-fake',
			{
				'vis-recommender__preview--horizontal' : this.props.horizontal,
				'vis-recommender__preview--vertical' : !this.props.horizontal
			}
		);
		const oldClassNames = classnames(
			'vis-recommender__preview',
			`vis-recommender__preview__size-${this.props.size}`,
			'vis-recommender__preview-fake',
			{
				'vis-recommender__preview--horizontal' : this.props.horizontal,
				'vis-recommender__preview--old_vertical' : !this.props.horizontal
			}
		);
		const oldVisBoxClassNames = classnames(
			'vis-recommender__preview__preview-box',
			'fake',
			{
				'vis-recommender__preview--horizontal__preview-box' : this.props.horizontal,
				'vis-recommender__preview--old_vertical__preview-box' : !this.props.horizontal
			}
		);

		let visBoxClassNames = classnames(
			'vis-recommender__preview__preview-box',
			'fake',
			{
				'vis-recommender__preview--horizontal__preview-box' : this.props.horizontal,
				'vis-recommender__preview--vertical__preview-box' : !this.props.horizontal
			}
		);

		classNames = (this.props.isNewLayout) ? classNames : oldClassNames;
		visBoxClassNames = (this.props.isNewLayout) ? visBoxClassNames : oldVisBoxClassNames;

		return (
			<div className={classNames} >
				<div className={visBoxClassNames} />
				{this.props.showTextPending ? <div className="fake" style={FAKE_STYLES.text}></div> : undefined}
			</div>
		);
	}

}

FakeVisualizationPreview.propTypes = {
	horizontal: PropTypes.bool,
	isNewLayout: PropTypes.bool,
	showTextPending: PropTypes.bool,
	size: PropTypes.oneOf(['small', 'medium', 'large'])
};

FakeVisualizationPreview.defaultProps = {
	horizontal: false,
	size: 'small'
};

export default FakeVisualizationPreview;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/preview/FakeVisualizationPreview.js